export enum ElectronicSignatureEnum {
  CondP = 'CondP',
  Info = 'Info',
  Sepa = 'Sepa'
}
